import $ from 'jquery'

$('#privacy-link').click(function () {
    $('#privacy').css({'display': 'flex'})
})

$('#cookies-link').click(function () {
    $('#cookies').css({'display': 'flex'})
})

$('#terms-link').click(function () {
    $('#terms').css({'display': 'flex'})
})

$('.popup .close').click(function () {
    $('.popup').css({'display': 'none'})
})